import { Injectable } from '@angular/core';
import { ApiService } from '../http/api.service';
import { environment } from 'src/environments/environment';
import { getHeaders} from '../http/modal/header';
import { UtilityService } from './utility.service';
import {
  CreateWorkspace,
  SavePreference,
} from '../http/modal/console-home.interface';
import {
  WorkspaceInterface,
  OpenWorkspaceInterface,
} from '../http/modal/workspace.interface';
import { SignoutInterface } from '../http/modal/signout.interface';
import { BehaviorSubject, Subject } from 'rxjs';
import { path } from 'src/environments/config';

export interface APPDETAILS {
  appId: string;
  appType: string;
  appName: string;
  branchId: string;
  branchName: string;
  moduleId: string;
  microAppHierarchy: string;
}
@Injectable({
  providedIn: 'root',
})

export class ConsoleHomeService {
  consoleSubject: Subject<Object> = new BehaviorSubject<object>(null);
  /**
   * Class Initializer
   * @param us;
   * @param apiService;
   */

  constructor(
    private readonly us: UtilityService,
    private readonly apiService: ApiService
  ) { }

  setConsoleSubject(data) {
    this.consoleSubject.next(data);
  }

  getApplicationListApi(queryParam) {
    const path = `/application?${queryParam}`;
    return this.apiService.get(`${environment.applicationUrlV2}${path}`, {
      headers: getHeaders(),
    });
  }

  getProjectListingApi(queryParam) {
    const path = `/project/listing?${queryParam}`;
    return this.apiService.get(`${environment.applicationUrlV2}${path}`, {
      headers: getHeaders(),
    });
  }

  createProjectApi(body) {
    return this.apiService.post(`${environment.applicationUrlV2}/project`, body, {
      headers: getHeaders(),
    });
  }

  updateProjectApi(projectId, body) {
    return this.apiService.put(`${environment.applicationUrlV2}/project/${projectId}`, body, {
      headers: getHeaders(),
    });
  }

  deleteProjectApi(projectId) {
    return this.apiService.delete(`${environment.applicationUrlV2}/project/${projectId}`, {
      headers: getHeaders(),
    });
  }

  linkAppsToProjectApi(projectId, body) {
    return this.apiService.post(`${environment.applicationUrlV2}/project/${projectId}/apps`, body, {
      headers: getHeaders(),
    });
  }

  unlinkAppsFromProjectApi(projectId, body) {
    return this.apiService.post(`${environment.applicationUrlV2}/project/${projectId}/apps/unlink`, body, {
      headers: getHeaders(),
    });
  }

  getProjectsApi(queryParam) {
    const path = `/project?${queryParam}`;
    return this.apiService.get(`${environment.applicationUrlV2}${path}`, {
      headers: getHeaders(),
    });
  }

  getAccountWorkspaceList(query) {
    const path = `/workspace/selection-list?${query}`;
    return this.apiService.get(`${environment.accountUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  getMicroAppBranchApi(queryParam) {
    const path = `/application/get-micro-app?${queryParam}`;
    return this.apiService.get(`${environment.applicationUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  getAccountList(query) {
    const path = `/account/filter?${query}`;
    return this.apiService.get(`${environment.accountUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  acceptRejectRequest(data, workspaceId) {
    const path = `/workspace/request-action?workspaceId=${workspaceId}`;
    return this.apiService.post(`${environment.accountUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  getNotification(param) {
    const path = `/workspace/notifications?${param}`;
    return this.apiService.get(`${environment.accountUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  getDomain() {
    let url = environment.cookieIamUrl.split('.com');
    return `${url[0]}.com`;
  }

  getPreference() {
    const path = `/navigation-server/preferences?name=ACCESS_LEVEL&domain=${environment.cookieIamDomainUrl}`;
    return this.apiService.get(`${environment.cookieIamUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  getAppManagementPreference() {
    let userId = this.us.getUserId();
    const path = `/navigation-server/preferences/list?userId=${userId}&domain=${environment.appMgUrl}`;
    return this.apiService.get(`${environment.cookieAppMUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  getOrgById(query) {
    const httpOptions = {
      requestid: `${Date.now()}`,
      ['Content-Type']: 'application/json',
      Authorization: environment.paAuth,
    } as any;
    const path = `/usermanagement/user/management/org/v1/getOrgByName?${query}`;
    return this.apiService.get(`${environment.cookieUrl}${path}`, {
      headers: httpOptions,
    });
  }

  getSourceAppBranch(sourceAppId: string) {
    const httpOptions = {
      requestid: `${Date.now()}`,
      ['Content-Type']: 'application/json',
      Authorization: environment.paAuth,
    } as any;
    const path = `/iam-resource-manager/application/sync/environments?sourceAppId=${sourceAppId}`;
    return this.apiService.get(`${environment.cookieAppMUrl}${path}`,{
      headers: httpOptions,
    })
  }

  /**
   * savePreference;
   * @param preferences;
   */
  public savePreference(preferences: object[],cookieUrl?, domain?) {
    const data = {
      userId: this.us.getUserId(),
      username: this.us.getUserName(),
      preferences,
    };
    let path = '/navigation-server/preferences/create';

    if (domain) {
      path = `${path}?domain=${domain}`;
    }

    return this.apiService.post<SavePreference>(
      `${cookieUrl?? environment.cookieUrl}${path}`,
      data,
      {
        headers: getHeaders(),
      }
    );
  }

  public savePreferenceOnAppM(preferences) {
    let url = environment.appMgUrl;
    const data = {
      userId: this.us.getUserId(),
      username: this.us.getUserName(),
      preferences,
    };
    const path = `/navigation-server/preferences/create?domain=${url}`;

    return this.apiService.post<SavePreference>(
      `${environment.cookieAppMUrl}${path}`,
      data,
      {
        headers: getHeaders(),
      }
    );
  }

  public savePreferenceOnDomain(preferences , domain) {
    const data = {
      userId: this.us.getUserId(),
      username: this.us.getUserName(),
      preferences,
    };
    const path = `/navigation-server/preferences/create?domain=${domain}`;

    return this.apiService.post<SavePreference>(
      `${environment.cookieAppMUrl}${path}`,
      data,
      {
        headers: getHeaders(),
      }
    );
  }

  public savePreferenceOnModule(preferences,primaryUrl,domain) {
    const data = {
      userId: this.us.getUserId(),
      username: this.us.getUserName(),
      preferences,
    };
    const path = `/navigation-server/preferences/create?domain=${domain}`;

    return this.apiService.post<SavePreference>(
      `${primaryUrl}${path}`,
      data,
      {
        headers: getHeaders(),
      }
    );
  }

  createCookie(data: object) {
    const path = '/navigation-server/cookies/create';
    return this.apiService.post<OpenWorkspaceInterface>(
      `${environment.cookieUrl}${path}`,
      data,
      {
        headers: getHeaders(path),
      }
    );
  }


  saveAppDetails(app: APPDETAILS) {
    const preferences = [
      {
        name: 'APP_ID',
        value: app.appId, // important for all apis
      },
      {
        name: 'APP_TYPE',
        value: app.appType,
      },
      {
        name: 'APP_NAME',
        value: app.appName,
      },
      {
        name: 'BRANCH_ID',
        value: app.branchId
      },
      {
        name: 'BRANCH_NAME',
        value: app.branchName
      },
      {
        name: 'MODULE_ID',
        value: app.moduleId
      },
      {
        name: 'MICROAPP_HIERARCHY',
        value: app.microAppHierarchy
      }

    ];
    return this.savePreferenceOnAppM(preferences);
  }

  /**
   * signout
   */
  signout() {
    const path = '/logout';
    return this.apiService.get<SignoutInterface>(
      `${environment.homeUrl}${path}`,
      {
        headers: getHeaders(path),
      }
    );
  }


  generatesslTokenApi() {
    const body = {
      data: "",
      orgId: 'VAHANASUPPORT-PFLEK25Z9X',
      appId: '69597172837091157953178',
      loginId: this.us.getUserName(),
    };

    const httpOptions = {
      requestid: `${Date.now()}`,
      withCredentials: true,
      orgid: 'VAHANASUPPORT-PFLEK25Z9X',
      appid: '69597172837091157953178',
      loginid: this.us.getUserName(),
      servicename: 'GENERATE_SSO_TOKEN',
      clientsecret: 'fd47e772-1db9-43fc-9ae5-5104934648c8',
    } as any;

    const endpoint = `${environment.vahana1url}backend/router/engine/v1/gatewayProcessor`;
    return this.apiService.post(`${endpoint}`, body, {
      headers: httpOptions,
    });
  }


  generateSSOToken(){
    const httpOptions = {
      requestid: `${Date.now()}`,
      clientsecret: '3f76d1bb-8bf8-4aef-b79b-1e5d9b0bd007',
      clientId: 'VAHANA~PORTAL'
    } as any;

    const path = `/iam-user-manager/api/v2/user/generate/ssoToken`

    return this.apiService.post(`${environment.cookieUrl}${path}`,{},{
      headers: httpOptions
    });
  }

  filterAccessReq(appId,subType?){
    const body = {
      pageNumber : 1,
      // pageSize : 1,
      // sourceAppId : appId
    };

    if(subType && subType.toLowerCase() !== 'middleware') {
      body['pageSize'] = 1;
      body['sourceAppId'] = appId;

    } else {
      body['pageSize'] = 50;
      body['destinationAppId'] = appId;
    }

    const queryParam = this.us.getObjToQueryParam(body);
    const httpOptions = {
      requestid: `${Date.now()}`,
      withCredentials: true,
    } as any;
    const path = `/iam-resource-manager/access-request/list?${queryParam}`;
    return this.apiService.get(`${environment.cookieAppMUrl}${path}`, {headers:httpOptions});
  }

  getAllRole(data) {
    const httpOptions = {
      requestid: `${Date.now()}`,
      ['Content-Type']: 'application/json',
      Authorization: environment.paAuth,
    } as any;
    // const path = ``
    // return this.apiService.post(`${environment.resourceUrl}${path}`, data);
    const path = `/policy/getUserRoles`;
    return this.apiService.post(`${environment.resourceUrl}${path}`, data,{
      headers: httpOptions,
    });
  }

  getCollectionListing(data) {
    return this.apiService.post(environment.fetchCollectionList, data, {
      headers: getHeaders(),
    });
  }

  verifyDestinationOrgId(desOrgId) {
    const path = `/iam-resource-manager/access-request/validate/destination/org?destinationOrgId=${desOrgId}`;
    return this.apiService
      .get(`${environment.cookieUrl}${path}`, { headers: getHeaders()});
  }

  getThemeList(workspaceId, branchId, userId?, accountHierarchy?, access_level?) {
    let url;
    if(userId && accountHierarchy && access_level) {
      url = `${environment.listingThemeUrl}?workspaceId=${workspaceId}&accountHeirarchy=${accountHierarchy}&accessLevel=${access_level}&userId=${userId}`;
    } else {
      url = `${environment.listingThemeUrl}?workspaceId=${workspaceId}&branchId=${branchId}`;
    }
    return this.apiService
      .get(url, { headers: getHeaders()});

  }

  createApplication(body) {
   const path = '/application';
   return this.apiService.post(`${environment.applicationUrlV2}${path}`,body, {headers: getHeaders()});
  }

  createPolicyApplication(body) {
    const path = '/application/policy-definition';
    return this.apiService.post(`${environment.applicationUrlV2}${path}`, body, { headers: getHeaders() });
  }

  viewApplicationDetail(appdata,appSubType?){
    this.us.navigateTo('/home');
    if(['mobile', 'web'].includes(appSubType?.toLowerCase())) {
      const body = {
        appid: appdata.id,
        branchid: "DEFAULT",
      };
      const queryParam = this.us.getObjToQueryParam(body);
      this.getMicroAppBranchApi(queryParam).subscribe(res => {
        this.us.hideLoader();
        if (res && res['code'].toLowerCase() === 'success') {
          if(res['data'] && res['data'].length>0){
            const microSubType = res['data'][0].subType;
            const data = [
              {
                name: 'APP_ID',
                value:appdata.id,
              },
              {
                name: 'APP_TYPE',
                value: 'APP' ,
              },
              {
                name: 'APP_NAME',
                value: appdata.appName,
              },
              {
                name: 'MICROAPP_HIERARCHY',
                value: res['data'][0].hierarchy,
              },
              {
                name: 'MODULE_ID',
                value: res['data'][0].id,
              },
              {
                name: 'BRANCH_ID',
                value: "DEFAULT",
              },
              {
                name: 'BRANCH_NAME',
                value: "DEVELOPMENT",
              },
              {
                name: 'APP_SUBTYPE',
                value: microSubType,
              }
            ];

            this.savePreferenceOnAppM(data).subscribe((prefRes) => {
              if (prefRes && prefRes['code'].toLowerCase() === 'success') {
                window.open(this.us.getAppOpenUrl(appdata, appSubType || microSubType), this.us.modules['app-development']['title']);
              }});
             }
          else{
            this.us.openSnackBar('no micro app found');
          }
        }
      });
    } else {
      if (!appdata.oldOrgId || !appdata.oldAppId) {
        console.log('Middleware orgid or appid is missing.');

        // this.us.openSnackBar(`Middleware orgid or appid is missing.`);
        return;
      }
        this.generateSSOToken().subscribe(res=>{
          console.log('ssores',res);
          if(res?.['code'] === 'success'){

           let ssotokenRes = res?.['data']?.['ssoToken'];
           let appId = appdata?.oldAppId ? appdata?.oldAppId : appdata.id;
           let workspaceId = appdata?.oldOrgId ? appdata?.oldOrgId : this.us.getWorkspaceId();

           console.log(`${'&appName=' + appdata?.appName + '&workspaceName=' + this.us.getWorkspaceName()}`)
           window.open(this.us.modules['middleware']['url'] + '?ssotoken=' + ssotokenRes +'&loginId=' + this.us.getUserName() + '&appId=' + appId + '&workspaceId=' + workspaceId + '&appName=' + appdata?.appName + '&workspaceName=' + this.us.getWorkspaceName(), this.us.modules['middleware']['title']);
          }else{
           this.us.openSnackBar(res?.['message']);
           console.log('failure sso res',res);
          }
         });
    }
  }

  verifyDuplicateAppName(queryParam) {
    const path = `/application/application-name?${queryParam}`;
    return this.apiService.get(`${environment.applicationUrlV2}${path}`, {headers: getHeaders()});
  }


  getMicroAppBranchList(app, appData?) {
    this.us.showLoader();
    const body = {
      appid: app.appId,
      branchid: "DEFAULT",
    };
    const queryParam = this.us.getObjToQueryParam(body);
    this.getMicroAppBranchApi(queryParam).subscribe(res => {
      this.us.hideLoader();
      if (res && res['code'].toLowerCase() === 'success') {
        if(res['data'] && res['data'].length>0){
          let applicationList = res['data'];
          let preferences = [
            {
              name: 'APP_ID',
              value: app.appId,
            },
            {
              name: 'APP_TYPE',
              value: app.type,
            },
            {
              name: 'APP_NAME',
              value: app.appName,
            },
            {
              name: 'MICROAPP_HIERARCHY',
              value:  applicationList[0].hierarchy,
            },
            {
              name: 'MODULE_ID',
              value: applicationList[0].id,
            },
            {
              name: 'BRANCH_ID',
              value: "DEFAULT",
            },
            {
              name: 'BRANCH_NAME',
              value: "DEVELOPMENT",
            },
            {
              name: 'APP_SUBTYPE',
              value: applicationList[0].subType,
            }
          ];
            if (!['mobile', 'web'].includes(applicationList[0].subType.toLowerCase())) {
            preferences.push(
              { name: 'MIDD_OLD_APP_ID', value: appData.oldAppId ?? appData.id },
              { name: 'MIDD_OLD_ORG_ID', value: appData.oldOrgId ?? this.us.getWorkspaceId() }
            );
          }

          this.savePreferenceOnAppM(preferences).subscribe((prefRes) => {
            if (prefRes && prefRes['code'].toLowerCase() === 'success') {
              window.open(
                this.us.getAppOpenUrl(appData || app, applicationList[0]?.subType),
                this.us.modules['app-development']['title']
              );
            }});
           }
        else{
          this.us.openSnackBar('no micro app found');
        }
      }
    });
  }
}
